document.addEventListener('DOMContentLoaded', () => {
    const initTimeline = () => {
        const timelineSection = document.querySelector('.timeline-section');
        if (!timelineSection) return;

        const progressLine = timelineSection.querySelector('.timeline-line--progress');
        const timelineItems = timelineSection.querySelectorAll('.timeline-item');
        const container = timelineSection.querySelector('.timeline-container');

        if (!progressLine || !container) return;

        // 1. Intersection Observer for fade-in animations
        const observerOptions = {
            rootMargin: '0px 0px -50px 0px',
            threshold: 0.1
        };

        const itemObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, observerOptions);

        timelineItems.forEach(item => {
            // Enable animations by adding the class
            item.classList.add('is-animated');
            itemObserver.observe(item);
        });

        // 2. Scroll Progress Line logic
        const updateProgress = () => {
            const containerRect = container.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            // The line starts coloring when the container top hits the middle of the screen
            const scrollThreshold = windowHeight / 2;

            const containerTop = containerRect.top;
            const containerHeight = containerRect.height;

            let progress = 0;

            if (containerTop < scrollThreshold) {
                const distancePassed = scrollThreshold - containerTop;
                progress = distancePassed / containerHeight;
                progress = Math.min(Math.max(progress, 0), 1);
            }

            progressLine.style.height = `${progress * 100}%`;

            // 3. Highlight states based on progress
            timelineItems.forEach(item => {
                const itemRect = item.getBoundingClientRect();
                // Bubble center is approximately at the top of the item in the new layout
                const itemPoint = itemRect.top + 20;

                if (itemPoint < scrollThreshold) {
                    item.classList.add('is-active');
                    item.classList.add('is-visible'); // Backup visibility
                } else {
                    item.classList.remove('is-active');
                }
            });
        };

        window.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress, { passive: true });
        updateProgress(); // Initial call
    };

    initTimeline();

    // Shopify Theme Editor compatibility
    document.addEventListener('shopify:section:load', (event) => {
        if (event.target.querySelector('.timeline-section')) {
            initTimeline();
        }
    });

    // Re-run on any section update in editor to catch alignment changes
    document.addEventListener('shopify:section:select', (event) => {
        if (event.target.querySelector('.timeline-section')) {
            window.dispatchEvent(new Event('scroll'));
        }
    });
});
